var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('img',{attrs:{"src":_vm.images,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"mask"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df98628","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/project-item.vue
// module id = null
// module chunks = 